import * as React from "react"
import { Route, Switch } from "react-router-dom"
import Loadable from "@bappweb/loadable"
import Header from "@components/globalmodules/header"
import MobileMenu from "@components/globalmodules/mobile-menu"
import Common from "./common"
import Block from "@bappweb/block"

const Main = () => {
  const routes = React.useMemo(
    () => ({
      Common,
      Guest: () => <Loadable loader={() => import("./guest")} />,
      Auth: () => <Loadable loader={() => import("./auth")} />,
      // eslint-disable-next-line react/no-multi-comp
      NotFound: () => <Loadable loader={() => import("./not-found-404")} />
    }),
    []
  )

  return (
    <>
      <Header />
      <Block type="main" className="bapp-main">
        <Switch>
          <Route exact path="/" component={routes.Common} />
          <Route path="/apis" component={routes.Common} />
          <Route path="/faq" component={routes.Common} />
          <Route path="/get-started" component={routes.Common} />
          <Route path="/how-it-works" component={routes.Common} />
          <Route path="/features/exchange-rates" component={routes.Common} />
          <Route path="/features/credit-interest-rates" component={routes.Common} />
          <Route path="/features/credit-payment-plan" component={routes.Common} />
          <Route path="/demo-form" component={routes.Common} />
          <Route path="/sftp-login" component={routes.Common} />
          <Route path="/sftp-forgotPassword" component={routes.Common} />
          <Route path="/sftp-forgotPassword-msg" component={routes.Common} />   
          <Route path="/sftp-changePassword" component={routes.Common} />  
          <Route path="/sftp-changePassword-smsOtp" component={routes.Common} />   
          <Route path="/sftp-changePassword-success" component={routes.Common} />            
          <Route path="/sftp-changePassword-error" component={routes.Common} /> 
          <Route path="/login" component={routes.Guest} />
          <Route path="/forgot-password" component={routes.Guest} />
          <Route path="/sign-up" component={routes.Guest} />
          <Route path="/auth" component={routes.Auth} />
          <Route component={routes.NotFound} />
        </Switch>
      </Block>
      <MobileMenu />
    </>
  )
}

export default Main
